import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { EnergyAnalysisMixCell } from "../model/types";

import { buildHeatmapOption } from "../lib/buildHeatmapOption";
import { buildSankeyOption } from "../lib/buildInsightOptions";
import { EnergyAnalysisInsightChart } from "./EnergyAnalysisInsightChart";

type EnergyAnalysisMixChartProps = {
  cells: EnergyAnalysisMixCell[];
  snapshotValueMax: number;
  title: string;
  unit: string;
  useTypes: string[];
  utilities: string[];
};

export const EnergyAnalysisMixChart = ({
  cells,
  snapshotValueMax,
  title,
  unit,
  useTypes,
  utilities,
}: EnergyAnalysisMixChartProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="w-full items-stretch gap-4">
      <EnergyAnalysisInsightChart
        className="w-1/2"
        height="32rem"
        iconName="GridIcon"
        option={buildSankeyOption(cells, unit)}
        title={`${title} · ${t("BuildingProfile.energyAnalysis.chartTypes.sankey")}`}
      />
      <EnergyAnalysisInsightChart
        className="w-1/2"
        height="32rem"
        iconName="GridIcon"
        option={buildHeatmapOption(cells, useTypes, utilities, snapshotValueMax)}
        title={`${title} · ${t("BuildingProfile.energyAnalysis.chartTypes.heatmap")}`}
      />
    </Stack>
  );
};
